'use strict';
import isString from 'lodash/isString';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';

export function ButtonView(props) {
  return (
    <button
      className={classNames(props.className, {
        [props.activeClassName]: props.active,
        [props.disabledClassName]: props.disabled,
      })}
      disabled={props.disabled}
      title={isString(props.title) ? props.title : null}
      ref={props.setButtonRef}
      onClick={props.onClick}
      onTouchStart={props.onTouchStart}
      onTouchEnd={props.onTouchEnd}
      onMouseDown={props.onMouseDown}
      onMouseUp={props.onMouseUp}
    >
      {props.leftIconClass ? <i className={classNames("icon", props.leftIconClass)} /> : null}
      {props.label ? (
        <span className={classNames(props.labelClass)}>
          {props.label}
        </span>
      ) : null}
      {props.rightIconClass ? <i className={classNames("icon", props.rightIconClass)} /> : null}
      {props.children}
    </button>
  );
}

ButtonView.propTypes = {
  className: T.string,
  activeClassName: T.string,
  disabledClassName: T.string,
  active: T.bool,
  disabled: T.bool,
  title: T.string,
  label: T.node,
  labelClass: T.string,
  leftIconClass: T.string,
  rightIconClass: T.string,
  setButtonRef: T.func,
  onClick: T.func,
  onTouchStart: T.func,
  onTouchEnd: T.func,
  onMouseDown: T.func,
  onMouseUp: T.func,
};

ButtonView.defaultProps = {
  className: 'BaseButton',
  activeClassName: 'BaseButton_active',
  disabledClassName: 'BaseButton_disabled',
  active: false,
  disabled: false,
  label: null,
  labelClass: '',
  leftIconClass: null,
  rightIconClass: null,
};



// WEBPACK FOOTER //
// ./src/js/components/buttons/Button/ButtonView.js